export const fleet = {
  fleetId: undefined,
  fleetName: undefined,
  carIds: [],
  createdBy: undefined,
};
